// Which Help & Support merchants get: EMS V2 (the in-house ticket backend, /support-v2) or the old
// Freshdesk-backed one (/escalation_management).
//
// Each environment is a separate build and CRA inlines these at build time:
//
//   REACT_APP_EMS_V2_ENABLED=true    -> EMS V2
//   REACT_APP_EMS_V2_ENABLED=false   -> the old Help & Support; no /support-v2 routes at all
//   not set                          -> EMS V2, except in a production build (REACT_APP_ENV=prod)
//
// So dev can be deployed to prod without switching merchants over. Go-live: set
// REACT_APP_EMS_V2_ENABLED=true in .env.prod and rebuild. Rolling back is the same line set to false.
const flag = (process.env.REACT_APP_EMS_V2_ENABLED || '').trim().toLowerCase()

export const EMS_V2_ENABLED = flag ? flag === 'true' : process.env.REACT_APP_ENV !== 'prod'

/** Where Help & Support lives in this build: the sidebar entry, the top bar button, old links. */
export const SUPPORT_PATH = EMS_V2_ENABLED ? '/support-v2' : '/escalation_management'
